import React, { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';

const getTrustpilotTheme = () => {
    if (typeof document !== 'undefined') {
        const bodyHasDarkMode = document.body && document.body.classList.contains('dark-mode');
        const htmlHasDarkMode = document.documentElement && document.documentElement.classList.contains('dark-mode');
        if (bodyHasDarkMode || htmlHasDarkMode) {
            return 'dark';
        }
    }

    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
        return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    }

    return 'light';
};

const TrustBoxReviewCount = ({ trustBoxRef, settings, trustpilotTheme }) => (
    /*< !--TrustBox widget - ReviewCollector-- >*/
    <div ref={trustBoxRef} // We need a reference to this element to load the TrustBox in componentDidMount.
        className="trustpilot-widget" // Renamed this to className.
        data-locale={settings.locale} data-template-id="5419b6a8b0d04a076446a9ad"
        data-businessunit-id={settings.trustPilotBusinessUnitId} //"6037915b07033f0001d0198b"
        data-style-height="20px"
        data-style-width="100%"
        data-theme={trustpilotTheme}>
        <a href={`https://trustpilot.com/review/${settings.customDomain}`} samesite='Secure' target="_blank" rel="noopener">Trustpilot</a>
    </div>
    /*<!--End TrustBox widget-- >*/
);


class TrustBoxContainer extends Component {
    constructor(props) {
        super(props);
        this.trustBoxRef = React.createRef();
    }

    componentDidMount() {
        if (window.Trustpilot) {
            window.Trustpilot.loadFromElement(this.trustBoxRef.current, true);
        }
    }

    render() {
        const { settings } = this.props;
        const trustpilotTheme = getTrustpilotTheme();
        return <TrustBoxReviewCount trustBoxRef={this.trustBoxRef} settings={settings} trustpilotTheme={trustpilotTheme} />;
    }
}


function mapStateToProps({ settings }) {
    return { settings };
}

export default withTranslation()(connect(mapStateToProps, null, null, { forwardRef: true })(TrustBoxContainer));
